import React from 'react'
import PropTypes from 'prop-types'

import './faqComponent.scss'

class FaqComponent extends React.Component {
    render() {
        const { title, topics } = this.props
        return <div className="faq-component">
            {title && <h3>{title}</h3>}
            <ul>
                {topics.map((topic, i) =>
                    <li key={i}><a href="">{topic}</a></li>
                )}
            </ul>
        </div>
    }
}

FaqComponent.propTypes = {
    title: PropTypes.string,
    topics: PropTypes.array.isRequired,
}

export default FaqComponent



// WEBPACK FOOTER //
// ./src/components/developerApi/developerSdk/Faq/FaqComponent.js